// src/api/netbotApi.js
import api from './axios';
export const getNetbotProviders = () =>
  api.get('/netbot/providers');
export const sendNetbotMessage = (mode, messages, context = null) =>
  api.post('/netbot/chat', { mode, messages, ...(context ? { context } : {}) });